import { render, staticRenderFns } from "./ArticlePaperPage.vue?vue&type=template&id=b2ea1046&scoped=true"
import script from "./ArticlePaperPage.vue?vue&type=script&lang=js"
export * from "./ArticlePaperPage.vue?vue&type=script&lang=js"
import style0 from "./ArticlePaperPage.vue?vue&type=style&index=0&id=b2ea1046&prod&lang=scss&scoped=true"
import style1 from "./ArticlePaperPage.vue?vue&type=style&index=1&id=b2ea1046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ea1046",
  null
  
)

export default component.exports